import React from 'react';

import PropTypes from 'prop-types';

const Step8 = ({ selectedPredio, datosComprador, datosImpuesto, certificadoEnTramite }) => {

    return (
        <div className="flex flex-col gap-5.5">
            <h3 className="mb-3 font-bold text-black dark:text-white">Resumen de la Liquidación</h3>

            <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
                <div className="border-b border-stroke py-4 px-6.5 dark:border-strokedark">
                    <h4 className="font-medium text-black dark:text-white">Datos del Predio</h4>
                </div>
                <div className="p-6.5">
                    <p><strong>Clave:</strong> {selectedPredio?.clave}</p>
                    <p><strong>Dirección:</strong> {selectedPredio?.Direccion}</p>
                </div>
            </div>

            <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
                <div className="border-b border-stroke py-4 px-6.5 dark:border-strokedark">
                    <h4 className="font-medium text-black dark:text-white">Datos del Comprador</h4>
                </div>
                <div className="p-6.5">
                    <p><strong>Cédula:</strong> {datosComprador?.identificacionComprador}</p>
                    <p><strong>Nombre:</strong> {datosComprador?.nombrePersona}</p>
                </div>
            </div>

            <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
                <div className="border-b border-stroke py-4 px-6.5 dark:border-strokedark">
                    <h4 className="font-medium text-black dark:text-white">Totales Calculados</h4>
                </div>
                <div className="p-6.5">
                    <div className="flex justify-between items-center py-2">
                        <p className="text-sm font-medium text-gray-500">Total Alcabala:</p>
                        <p className="text-lg font-semibold text-gray-900">${parseFloat(datosImpuesto?.alcabala?.total || 0).toFixed(2)}</p>
                    </div>
                    <div className="flex justify-between items-center py-2 border-t border-gray-200">
                        <p className="text-sm font-medium text-gray-500">Total Utilidad:</p>
                        <p className="text-lg font-semibold text-gray-900">${parseFloat(datosImpuesto?.utilidad?.total || 0).toFixed(2)}</p>
                    </div>
                    <div className="flex justify-between items-center py-2 border-t border-gray-200">
                        <p className="text-lg font-bold text-gray-900">Total a Pagar:</p>
                        <p className="text-2xl font-bold text-primary">${(parseFloat(datosImpuesto?.alcabala?.total || 0) + parseFloat(datosImpuesto?.utilidad?.total || 0)).toFixed(2)}</p>
                    </div>
                </div>
            </div>

            {certificadoEnTramite ? (
                <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-6.5 text-center text-danger">
                    <p className="font-bold text-lg">¡Atención! Existen trámites pendientes en proceso.</p>
                </div>
            ) : (
                <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark p-6.5 text-center text-success">
                    <p>No presenta trámites en proceso.</p>
                </div>
            )}
        </div>
    );
};

Step8.propTypes = {
    selectedPredio: PropTypes.object,
    datosComprador: PropTypes.object,
    datosImpuesto: PropTypes.object,
    certificadoEnTramite: PropTypes.bool
};

export default Step8;